var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBackward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5302 17.9697C10.8231 18.2626 10.8231 18.7374 10.5302 19.0303C10.2373 19.3232 9.76241 19.3232 9.46952 19.0303L3.67663 13.2374C2.99321 12.554 2.99321 11.446 3.67663 10.7626L9.46952 4.96967C9.76241 4.67678 10.2373 4.67678 10.5302 4.96967C10.8231 5.26256 10.8231 5.73744 10.5302 6.03033L5.31051 11.25H19.9998C20.4141 11.25 20.7498 11.5858 20.7498 12C20.7498 12.4142 20.4141 12.75 19.9998 12.75H5.31051L10.5302 17.9697Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackward);
export default __webpack_public_path__ + "static/media/arrow-backward.463b2dd9a9f26cd4610d752bbc1bf421.svg";
export { ForwardRef as ReactComponent };